import { useState } from 'react';
import { mensagemDeErro } from '../../utils/Utils';
import { Perfil } from './typePerfil';
import { usePerfilContexto } from '../../contextos/PerfilContexto';
import useAvisos from '../../hooks/useAviso';
import api from '../api';

const API_URL = '/usuarios';

/**
 * Operações de perfil autenticadas. A sessão/login em si vive no AuthContext;
 * aqui ficam só as ações sobre o próprio perfil (atualizar / excluir).
 */
export function usePerfis() {
  const { perfil, setPerfil } = usePerfilContexto();
  const [loading, setLoading] = useState<boolean>(false);
  const [salvando, setSalvando] = useState<boolean>(false);
  const { adicionarAviso } = useAvisos();

  const updatePerfil = async (id: number, updatedPerfil: Perfil) => {
    if (!perfil || !perfil.id) {
      return;
    }
    setSalvando(true);
    try {
      const { data } = await api.put(`${API_URL}/${id}`, updatedPerfil);
      setPerfil({ ...perfil, ...data });
      adicionarAviso('Perfil atualizado.', 'sucesso');
    } catch (err) {
      adicionarAviso(mensagemDeErro(err) || 'Não foi possível atualizar o perfil.', 'erro');
    } finally {
      setSalvando(false);
    }
  };

  const deletePerfil = async (id: number) => {
    setLoading(true);
    try {
      await api.delete(`${API_URL}/${id}`);
    } catch (err) {
      adicionarAviso(mensagemDeErro(err) || 'Não foi possível excluir a conta.', 'erro');
    } finally {
      setLoading(false);
    }
  };

  return {
    perfil,
    setPerfil,
    loading,
    salvando,
    updatePerfil,
    deletePerfil
  };
}
